import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Leaf, Clock, Heart } from 'lucide-react';
const pillars = [{
  icon: Brain,
  title: 'BODY',
  subtitle: '(Neuroscience)',
  desc: "The Body Check is grounded in the same science that Dr. Curt Thompson — psychiatrist and author of Anatomy of the Soul — uses to explain how the nervous system and spiritual discernment are inseparably linked. A dysregulated body cannot produce clear discernment. Regulation is not optional — it's the prerequisite."
}, {
  icon: Leaf,
  title: 'FRUIT',
  subtitle: '(Biblical Wisdom)',
  desc: '"By their fruit you will recognize them." (Matthew 7:16) The Fruit Projection is not a new concept — it\'s one of the oldest wisdom frameworks in existence, applied to the specific terrain of modern relationship decisions.'
}, {
  icon: Clock,
  title: 'TIMING',
  subtitle: '(Practical Action)',
  desc: "As Emily P. Freeman teaches in The Next Right Thing — clarity doesn't always come all at once. Sometimes it comes one step at a time, when you stop demanding the whole map and ask for just the next faithful move."
}, {
  icon: Heart,
  title: 'EMBODIED FAITH',
  subtitle: '(Wholeness)',
  desc: "Dr. Anita Phillips, therapist and pastor, reminds us that wholeness is not just spiritual — it's embodied. Your body is not the enemy of your faith. It's part of how you hear."
}];
export function ProofSection() {
  return <section className="py-20 md:py-28 px-4 bg-cream watermark-bg" data-id="element-218">
      <div className="max-w-5xl mx-auto" data-id="element-219">
        <div className="text-center mb-16" data-id="element-220">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-221">
            Why This Framework Works
          </h2>
          <p className="text-xl text-charcoal/70 font-serif italic" data-id="element-222">
            Grounded in the four pillars of sound discernment
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-223">
          {pillars.map((pillar, index) => {
          const Icon = pillar.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white p-8 rounded-2xl shadow-sm border border-warm-gray flex flex-col md:flex-row gap-6 items-start" data-id="element-224">
                <div className="w-14 h-14 rounded-full bg-gold/10 flex items-center justify-center flex-shrink-0" data-id="element-225">
                  <Icon className="w-7 h-7 text-gold" data-id="element-226" />
                </div>
                <div data-id="element-227">
                  <h4 className="text-xl font-bold mb-1" data-id="element-228">
                    {pillar.title}{' '}
                    <span className="text-charcoal/50 text-base font-normal" data-id="element-229">
                      {pillar.subtitle}
                    </span>
                  </h4>
                  <p className="text-charcoal/80 leading-relaxed text-sm md:text-base" data-id="element-230">
                    {pillar.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}